import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LeadsService } from '../../leads/leads.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { TermsAndConditionsComponent } from 'src/app/utils/dialog-modals/terms-and-conditions/terms-and-conditions.component';
import { MatStepper } from '@angular/material/stepper';
import { SharedService } from 'src/app/utils/services/shared.service';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {
  title = 'ihs-form';
  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  @ViewChild('stepper') stepper: MatStepper;

  primaryBusinessList = [];
  storeLocations = [];
  Turnover = []
  opertunity = [];
  formData1 = [];
  formData2 = [];
  formData3 = [];
  finalFormData: any;
  businessContinuityProof = [];
  monthly_turnover = [
    { id: 1, turnover: "<50k" },
    { id: 2, turnover: "50k to 1lac" },
    { id: 3, turnover: "2lac to 3lac" },
    { id: 4, turnover: "3lac to 5lac" },
    { id: 5, turnover: "5lac to 7lac" },
    { id: 6, turnover: "7lac to 10lac" },
    { id: 7, turnover: "10lac to 20lac" },
    { id: 8, turnover: ">20lac" }];
  showReferralEmailId = false;
  // public emailRegExp = '^([a-zA-Z0-9]+@[a-zA-Z]{1,}\\.(\\bcom\\b|\\bCOM\\b))$';
  public emailRegExp = new RegExp('^([a-zA-Z0-9]+[.]?[a-zA-Z0-9]{1,})+@[a-zA-Z]{1,}\\.\\bcom\\b$', 'i');
  constructor(private _formBuilder: FormBuilder, private leadService: LeadsService, public snackBar: MatSnackBar, private _location: Location, public dialog: MatDialog, public sharedService: SharedService) { }

  ngOnInit() {
    this.firstFormGroup = this._formBuilder.group({

      name: ['', [Validators.required, Validators.pattern('^[a-zA-Z \-\']+')]],
      email_id: ['', [Validators.required, Validators.pattern(this.emailRegExp)]],
      phone: ['', [Validators.required, Validators.pattern('^(0|[0-9][0-9]*)$')]],
      residental_address: ['', [Validators.required]],
      store_name: ['', [Validators.required, Validators.pattern('^[a-zA-Z \-\']+')]],
      store_address: ['', [Validators.required]],
      primary_business: ['', [Validators.required]],
      other_business: [''],
      pincode: ['', [Validators.required, Validators.pattern('^(0|[1-9][0-9]*)$')]],
      location: ['', Validators.required],
      other_location: [''],
      // lattiude: ['', [Validators.required]],
      // longitude: ['', Validators.required],
      monthly_turnover: ['', Validators.required],

    });

    this.secondFormGroup = this._formBuilder.group({
      is_passport_available: ['', Validators.required],
      is_aadhar_available: ['', Validators.required],
      is_voterid_available: ['', Validators.required],
      is_dl_available: ['', Validators.required],
      is_pan_available: ['', Validators.required],
      is_bank_available: ['', Validators.required],
      is_gst_available: ['', Validators.required],
      is_rented_owned: ['', Validators.required],
      is_rented_aggrement_available: ['', Validators.required],
      is_electricy_gas_landline_bill_available: ['', Validators.required],
      is_shop_establishment_certificate: ['', Validators.required],
      document: [''],
      // document_number: [''],
    });

    this.thirdFormGroup = this._formBuilder.group({
      enroll_ihs_as_delivery_partner: ['', Validators.required],
      intrested: ['', Validators.required],
      opportinunity_source: ['', Validators.required],
      applied_earlier: ['', Validators.required],
      contact_source: ['', Validators.required],
      information_correct: ['', Validators.required],
      accept_terms_conditions: ['', Validators.required],
      referred_by: [''],
    });
    this.getMasterData();

  }

  // To Get the all the related dropdown values
  getMasterData() {
    let obj = {
      "regionCode": 'in'
    }
    this.leadService.getDropdownsData('lead/masters',obj).subscribe((response) => {
      if (response.success) {
        this.primaryBusinessList = response.payload.primaryBusiness;
        this.storeLocations = response.payload.location;
        this.opertunity = response.payload.opertunity;
        this.businessContinuityProof = response.payload.businessContinuityProof;
      } else {
      }
    }, (err) => {
    })
  }
  check() {
  }
  Validate() {
    if (this.secondFormGroup.value.is_passport_available == "false" &&
      this.secondFormGroup.value.is_aadhar_available == "false" &&
      this.secondFormGroup.value.is_voterid_available == "false" &&
      this.secondFormGroup.value.is_dl_available == "false") {
      this.snackBar.open('please provide atleast one personal information proof', 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
      return;
    }
  }
  viewPolicy() {
    const dialogRef = this.dialog.open(TermsAndConditionsComponent, {
      width: '100%',
      height: '80%',
      panelClass: 'my-custom-dialog-class-reject'
    });
  }
  submit() {
    this.formData1 = this.firstFormGroup.value;
    this.formData2 = this.secondFormGroup.value;
    this.formData3 = this.thirdFormGroup.value;
    this.finalFormData = { ...this.formData1, ...this.formData2, ...this.formData3 };

    if (this.finalFormData.opportinunity_source != 'Referral') {
      this.finalFormData.referred_by = '';
    }

    if (this.finalFormData.is_passport_available == "false" &&
      this.finalFormData.is_aadhar_available == "false" &&
      this.finalFormData.is_voterid_available == "false" &&
      this.finalFormData.is_dl_available == "false") {
      this.snackBar.open('please provide atleast one personal information proof', 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
      return;
    }
    // if (this.finalFormData.is_bank_available == "false" &&
    //   this.finalFormData.is_gst_available == "false" &&
    //   this.finalFormData.is_pan_available == "false") {
    //   this.snackBar.open('please provide atleast one financial information proff', 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
    //   return;
    // }
    // if (this.finalFormData.document_number)
    //   this.finalFormData.document_number = this.finalFormData.document_number.toString();
    if (this.finalFormData.primary_business != 13)
      delete this.finalFormData['other_business'];
    if (this.finalFormData.location != 13)
      delete this.finalFormData['other_location'];
    if (this.finalFormData.is_shop_establishment_certificate != 'false') {
      // delete this.finalFormData['document_number'];
      delete this.finalFormData['document'];
    }
    delete this.finalFormData['information_correct'];
    this.sharedService.display(true);
    this.finalFormData['regionCode'] = 'in';
    this.leadService.createLead('lead/owner/create', this.finalFormData).subscribe((response) => {
      if (response) {
        this.snackBar.open('Lead Created successfully', 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
        this.firstFormGroup.reset(true);
        this.secondFormGroup.reset(true);
        this.thirdFormGroup.reset(true);
        this.sharedService.display(false);
        // this.stepper.reset();

        setTimeout(() => {
          window.location.href = "https://ihs.mobinius.com/website/";
        }, 500)
      } else {
      }
    }, (err) => {
      if (err.error)
        this.snackBar.open(err.error?.message, 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
      else
        this.snackBar.open('something went wrong', 'okay', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'center' });
      this.sharedService.display(false);
    });
  }
  navigateToWebsite(){
    window.location.href = "https://ihs.mobinius.com/website/";
  }

  opportunityChange(event) {
    if (event == 'Referral' || event == 'referral') {
      this.thirdFormGroup.get('referred_by').setValidators([Validators.required, Validators.pattern(this.emailRegExp)]);
      this.thirdFormGroup.get('referred_by').updateValueAndValidity();
      this.showReferralEmailId = true;
    } else {
      this.thirdFormGroup.get('referred_by').clearValidators();
      this.thirdFormGroup.get('referred_by').updateValueAndValidity();
      this.showReferralEmailId = false;
    }
  }

}

